import type { Option } from "@/components/CheckboxGroup";
import type { FilterConfig } from "hsl-core/FundExplorer";

export default function toCheckboxOptions(
	fc: FilterConfig,
	countFn?: (filterKey: string, optionKey: string) => number,
) {
	return fc.options.reduce((acc, o) => {
		const count = countFn?.(fc.key, o.key);
		const disabled = typeof count === "number" ? count === 0 : false;
		if (disabled && fc.hideWhenDisabled) {
			return acc;
		}
		acc.push({
			value: o.key,
			label: o.label,
			disabled,
		});
		return acc;
	}, [] as Option[]);
}
